import React from "react";
import { APICall } from "../../api_helper";
import { useQueryWrapper } from "../../helper";
import { ListPageCreationProps } from "./NewPageComponent";
import { NewNewModalWithFormComponent } from "../new_modal/NewNewModalWithFormComponent";
import {
  ListPageFilterComponent,
  ListPageFilterComponentProps,
} from "./ListPageFilterComponent";

export const NewListPageComponent = (props: {
  props: NewListPageComponentProps;
}) => {
  const [items, setItems] = React.useState<any[]>([]);
  const [reloadKey, setReloadKey] = React.useState(0);
  const [filterData, setFilterData] = React.useState<any>(
    props.props.filterComponentProps?.startingData ?? {},
  );

  useQueryWrapper(
    props.props.query.documentNode,
    {
      ...props.props.queryVariables,
      __reloadKey: reloadKey,
      filter: filterData,
    },
    (data) => {
      console.log("Data received from query: ", data);
      setItems(data[props.props.query.key]);
    },
  );

  return (
    <>
      {props.props.creationProps && (
        <>
          <NewNewModalWithFormComponent
            props={{
              header: `Create ${props.props.itemName}`,
              triggerProps: {
                label: `Create ${props.props.itemName}`,
                type: "button",
              },
              formComponentProps: props.props.creationProps.formComponentProps,
              apiCall: props.props.creationProps.apiCall,
              callback: () => setReloadKey((prev) => prev + 1),
            }}
          />
        </>
      )}
      {props.props.filterComponentProps && (
        <ListPageFilterComponent
          props={props.props.filterComponentProps}
          data={filterData}
          setData={setFilterData}
        />
      )}
      <div className="card-list">
        {items.map((item) => (
          <props.props.card
            key={item.id}
            data={item}
            setReloadKey={setReloadKey}
            pageData={items}
            setPageData={setItems}
          />
        ))}
      </div>
    </>
  );
};

export type NewListPageComponentProps = {
  type: "list_page";
  query: APICall;
  queryVariables: any;
  itemName: string;
  creationProps?: ListPageCreationProps;
  filterComponentProps?: ListPageFilterComponentProps;
  card: (props: {
    data: any;
    setReloadKey: any;
    pageData: any;
    setPageData: any;
  }) => JSX.Element;
};
